export class PaginationList<T> {
  constructor(
    public items: T[] = [],
    public totalItems: number = 0,
  ) {}
}
